module.exports = __webpack_public_path__ + "img/swiper-bg-mobile2.e11c9b89.jpg";